bq.global.searchInit = function() {
  var $container = $('.search-form');
  var input = $container.find('.search-input');
  var $suggestions = $container.find('.default-suggestions');
  var $typeahead = $container.find('.tt-dropdown-menu');
  var $selectOption = $container.find('.select-option');
  var $select = $container.find('.search-select');

  input.on('keydown keyup', function() {
    if($typeahead.height() <= 5) {
        $suggestions.show();
    }
  });
  $container.on('typeahead:updated', function() { $suggestions.hide(); });

  $('.search-form .icon-input-search:not(.observable)').addClass('observable').on('click', function(){
    $(this).closest('form').submit();
  });

  $container.on('show.bs.dropdown', function() {
    if(bq.helper.mq.is('xs')) { return; }
    var div = $(this).closest('.dropdown');
    div.removeClass('opennow');
    div.delay(530).queue('fx', function() {
        $.dequeue(this);
        $(this).addClass('opennow');
    });
  });

  input.on('focusin', function(){
    var inputElement  = input[0];
    var suggestDisabled = $(inputElement).hasClass('suggest-disabled');
    if(bq.helper.mq.is('xs') || suggestDisabled) { return; }
    var cont = $(this).closest('.dropdown');
    if(cont.hasClass('open')) { return; }

    cont.find('.dropdown-menu').dropdown('toggle');
  });

  $select.on('click', function() {
    $select.css('opacity', '1');
  });

  $select.on('change', function() {
    var $sel = $(this);
    var $option = $sel.children("option").filter(":selected");
    var $input = $sel.closest('form').find($option.data('input'));
    $selectOption.text($option.text());

    $sel.closest('form').attr('action', $option.data('url'));


    var $val = $sel.closest('form').find('.search-input-container').not($option.data('input')).find('.search-input').val();

    $('.search-input').val($val);

    $sel.closest('form').find('.search-input-container').addClass('hide');
    $input.removeClass('hide');

  });

  $container.find('form').on('submit', function() {
    var $this = $(this);
    var valid = true;
    if($this.data('Parsley')) {
      valid = $this.parsley().validate();
    }

    var $sel = $this.find('.search-select');

    if(valid) {
      var $option = $sel.children("option").filter(":selected");
      var $input = $sel.closest('form').find($option.data('input'));

      $('.search-input-container.hide').find('.search-input').remove();

    } else {
      return false;
    }
  });

    $("#suggestion-list")
        .on('click', function(e){

            e.preventDefault();
            e.stopImmediatePropagation();

            if( $(e.target).is('a') ) {
                // allow go by any link URL
                window.location.href = $(e.target).attr('href');
            }
        });

};

bq.global.searchClick = function(e) {

};

bq.global.topBarInit = function() {
  var $menu = $('.top-bar-nav');

  //loop through each li > a to get top level links, ahve to catch a click and li event ;/
  $menu.find('> li:not(.observable)').addClass('observable')
      .on('click', '[data-toggle="dropdown"]', bq.global.topNavClick)
      .on('show.bs.dropdown', bq.global.topNavClick);

  $(document).off('click.bqMobileSearch').on('click.bqMobileSearch', function(e) {
    if($(e.target).closest('#mini-search').length) { return; }

    $('.theme-new #mini-search .mobile-search-open').removeClass('mobile-search-open');
    $('.theme-new #mini-search > a').attr('aria-expanded', false);
  });

  $('.back-btn').on('click', function() {
      if ($(this).data('target')) {
          window.location = $(this).data('target');
      } else if (window.frames.length) {
          // fix page history issue with loaded iframe
          if (window.document.referrer) {
              window.location = window.document.referrer;
          } else {
              window.history.go(-(window.frames.length + 1));
          }
      } else {
          window.history.back();
      }
  });
};

bq.global.topNavClick = function(e){

    //if not mobile, return
    if(!bq.helper.mq.is('xs')) { return; }

    var el = $(this);
    var $navItem = el.is('li') ? el : el.closest('li');

    if(
      $('body').hasClass('theme-new')
      && $navItem.hasClass('mini-cart-link')
      && !Modernizr.mq('(max-width: 480px)')
    ) {
      return;
    }

    e.stopImmediatePropagation();

    if(el.is('li')) {
      el = el.find('> a');
    }

    var $searchLink = el.closest('.search-link');

    if($('body').hasClass('theme-new') && $searchLink.length) {
      if(!el.is('a')) { return; }

      var $mobileSearch = $searchLink.children('.typeahead-form-container');
      var isOpen = !$mobileSearch.hasClass('mobile-search-open');

      $mobileSearch.toggleClass('mobile-search-open', isOpen);
      el.attr('aria-expanded', isOpen);

      if(isOpen) {
        $mobileSearch.find('.search-input:visible').first().focus();
      }

      return false;
    }

    $('.theme-new #mini-search .mobile-search-open').removeClass('mobile-search-open');
    $('.theme-new #mini-search > a').attr('aria-expanded', false);

    if($('#mobileSideBar').length == 0) {
      //create sidebar, copy content, init slidebars again?
      $('body').append('<div class="sb-slidebar sb-right sb-style-push" id="mobileSideBar"></div>');
      bq.global.sidebarMiniCartInit();
      bq.global.searchInit();
      //init typeahead

      $('#mobileSideBar [data-bq="typeahead"]').each(function () {
        var $el = $(this);
        $el.bqtypeahead($el.data());
      });

      bq.global.parsley.setup();

      bq.global.slideBars = new $.slidebars({scrollLock: true});
    }

    //show the right one
    $('#mobileSideBar .cart-menu, #mobileSideBar .typeahead-form-container').addClass('hide').removeClass('show open');
    $('#'+$(el).parent().data('mobileId')).addClass('show open').removeClass('hide');

    bq.global.topNavShowSideBar(el);
    return false;
};

bq.global.topNavShowSideBar = function(el){
  bq.global.slideBars.slidebars.toggle('right');
};

bq.global.sidebarMiniCartInit = function() {
  $('.top-bar-nav .cart-menu, .top-bar-nav .typeahead-form-container').each(function(){
    var $_this = $(this);
    //clone with events
    var $_clone = $_this.clone(true);
    $_clone.removeClass('hidden-xs');

    var id = bq.helper.uniqueId($_clone);
    $_this.parent().data('mobileId', id);
    $('#mobileSideBar').append($_clone);
  });

  $('.top-bar-nav .mini-cart-link')
      .on('bq.ajaxAction.cart.update', bq.global.sidebarMiniCartUpdate);
};

bq.global.sidebarMiniCartUpdate = function() {
    //if not mobile, return
    if(!bq.helper.mq.is('xs') || !$(this).data('mobileId')) { return; }
    $('#' + $(this).data('mobileId')).remove();
    //clone with events
    var $_clone = $(this).find('.dropdown-menu').clone(true);
    $($_clone).attr('id', $(this).data('mobileId'));
    $('#mobileSideBar').append($_clone);
    $('#'+$(this).data('mobileId')).addClass('show open').removeClass('hide');
};

bq.init.push(bq.global.searchInit);
bq.init.push(bq.global.topBarInit);

bq.global.slideBars = new $.slidebars({scrollLock: true});
